module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMzc1IDEzLjM2MjNMNy4zNzUgNy4zNjIzMUwxMy4zNzUgMTMuMzYyM00xMy4zNzUgMS4zNjIzTDcuMzczODYgNy4zNjIzMUwxLjM3NSAxLjM2MjMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/closeLastWeek.svg
// module id = DXG6
// module chunks = 0